/**
 * We should optimize the payments as seen here:
 * https://github.com/stripe/stripe-payments-demo/blob/master/public/javascripts/payments.js
 *
 * We might be able to add paypal as well.
 */


/**
 * Fetch polyfill
 *
 * @see https://github.com/github/fetch
 */
import 'whatwg-fetch'


const stripe   = Stripe( window.stripePublicKey )
const elements = stripe.elements()

const donationForm     = document.getElementById("donation-formular")
const submitButton     = document.getElementById("donation-submit")
const messageContainer = document.getElementById("donation-errors")
const cardMessageContainer = document.getElementById("donation-card-errors")

const donationCustomAmount = document.getElementById("donation-amount-custom")

const errorMessages = {
  "donation-card-holder": "Bitte geben Sie Ihren vollständigen Namen an.",
  "donation-email":       "Bitte geben Sie eine gültige E-Mail-Adresse an.",
  "donation-street":      "Bitte geben Sie Ihre Straße an.",
  "donation-zip":         "Bitte geben Sie Ihre Postleitzahl an.",
  "donation-city":        "Bitte geben Sie Ihren Wohnort an.",
  "donation-country":     "Bitte geben Sie Ihr Land an.",
  "donation-terms":       "Sie müssen die Datenschutzerklärung akzeptieren, um fortzufahren.",
  "donation-amount-min":  "Bitte geben Sie einen Mindestbetrag von 5 Euro ein.",
}

let donationAmount     = 20



/* ---- Define styles ---------------------------------- */

const style = {
  base: {
    color: "#575C57",
    fontFamily: "sans-serif",
    fontSmoothing: "antialiased",
    fontSize: "20px",
    "::placeholder": {
      color: "#A6A6A6"
    }
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a"
  }
}



/* ---- Helper functions -------- ---------------------- */

const getUnitsForDonation = amount => {
  const costPerUnit = 40
  return (amount / costPerUnit)
}

const getDonationAmount = () => {
  const radio = document.querySelector("input[name='donation-amount']:checked")
  const radioValue  = radio ? radio.value : donationAmount
  return parseFloat(radioValue === "choose" ? donationCustomAmount.value : radioValue)
}

const updatePayment = () => {
  const donationAmount = getDonationAmount()
  const paymentIntent  = donationForm.getAttribute("data-stripe-intent-id")

  return fetch(`/stripe-api/update-intent/${paymentIntent}`, {
    method: "POST",
    body: JSON.stringify({
      amount: donationAmount,
      description: document.getElementById("donation-message").value
    })
  }).then(response => response.json())
}

const doScrolling = (elementY, duration) => {
  const startingY = window.pageYOffset
  const diff      = elementY - startingY
  let start

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    // Elapsed milliseconds since start of scrolling.
    let time = timestamp - start
    // Get percent of completion in range [0, 1].
    let percent = Math.min(time / duration, 1)

    window.scrollTo(0, startingY + diff * percent)

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}



/* ---- Error handling within card and formular -------- */

const showErrorMessage = (msg, container) => {
  container.innerHTML = msg
  container.classList.remove("is-hidden")
}

const hideErrorMessage = (container) => {
  container.innerHTML = ""
  container.classList.add("is-hidden")
}

const showSuccessMessage = () => {
  const successMessageContainer = document.getElementById("donation-success")

  const amount = getDonationAmount()
  const units  = getUnitsForDonation(amount)

  const resultUnits = successMessageContainer.querySelector(".units")
  resultUnits.innerHTML  = units.toString().replace(/\./, ',') + " " + resultUnits.getAttribute("data-suffix")

  successMessageContainer.classList.remove("is-hidden")
}



/* ---- Mount card element ---------------------------- */

const card = elements.create("card", { style })
card.mount("#donation-card")

card.addEventListener("change", event => {
  if (event.error) {
    showErrorMessage(event.error.message, cardMessageContainer)
  } else {
    hideErrorMessage(cardMessageContainer)
  }
})



/* ---- Create payment request button ------------------ */

// const paymentRequest = stripe.paymentRequest({
//   country: "DE",
//   currency: "eur",
//   total: {
//     label: "Spende Hippotherapienetz e.V.",
//     amount: (getDonationAmount() * 100),
//     pending: true
//   },
//   requestPayerName:  true,
//   requestPayerEmail: true
// })

// const prButton = elements.create("paymentRequestButton", {
//   paymentRequest,
//   style: {
//     paymentRequestButton: {
//       type: 'donate', // default: 'default'
//       theme: 'dark',  // 'dark' | 'light' | 'light-outline', // default: 'dark'
//       height: '64px', // default: '40px', the width is always '100%'
//     },
//   }
// })

// (async () => {
//   const result = await paymentRequest.canMakePayment()

//   if (result) {
//     prButton.mount("#payment-request-button")
//   } else {
//     document.getElementById("payment-request-button").parentElement.style.display = "none"
//   }


//   paymentRequest.on('paymentmethod', async (ev) => {

//     const {
//       error: confirmError,
//       paymentIntent,
//     } = await stripe.confirmPaymentIntent(clientSecret, {
//       payment_method: ev.paymentMethod.id,
//     })

//     if (confirmError) {
//       // Report to the browser that the payment failed, prompting it to
//       // re-show the payment interface, or show an error message and close
//       // the payment interface.
//       ev.complete('fail')
//     } else {
//       // Report to the browser that the confirmation was successful, prompting
//       // it to close the browser payment method collection interface.
//       ev.complete('success')
//       // Let Stripe.js handle the rest of the payment flow.
//       const { error } = await stripe.handleCardPayment(clientSecret)

//       if (error) {
//         // The payment failed -- ask your customer for a new payment method.
//         showErrorMessage("Die ausgewählte Zahlungsmethode weißt ein Problem auf. Bitte wählen Sie eine andere Zahlungsmethode oder probieren Sie es erneut.", messageContainer)

//       } else {
//         donationForm.classList.add("is-finished")
//         showSuccessMessage()
//         doScrolling(0, 300)
//       }
//     }
//   })

// })()



/* ---- Form validation -------------------------------- */

const validateDonationForm = () => {
  const inputs      = donationForm.querySelectorAll("input[required], textarea[required]")

  let inputsToCheck = {}
  let errors        = []

  /* Check for text fields */
  for (var i = inputs.length - 1; i >= 0; i--) {
    let input = inputs[i]
    let name = input.getAttribute("name")
    if (!inputsToCheck[name]) {
      inputsToCheck[name] = input
    }
  }

  for (let i in inputsToCheck) {
    if (inputsToCheck.hasOwnProperty(i)) {
      let input = inputsToCheck[i]

      let value = input.value,
          name  = input.getAttribute("name")

      if (!value) {
        errors.push(name)
      }
    }
  }

  /* Check for special fields: terms and amount */
  if (!document.getElementById("donation-terms").checked) {
    errors.push("donation-terms")
  }
  if (getDonationAmount() < 5) {
    errors.push("donation-amount-min")
  }

  return errors
}

const getErrorMessage = errors => {
  let msg = "Bitte korrigieren Sie die folgenden Fehler, um fortfahren zu können:"
  msg += "<ul>"

  for (var i = errors.length - 1; i >= 0; i--) {
    let error = errors[i]
    msg += `<li>${errorMessages[error] || error}</li>`
  }

  msg += "</ul>"

  return msg
}


/* ---- Submit handler -------------------------------- */

const clientSecret = submitButton.dataset.secret

submitButton.addEventListener("click", async (event) => {
  event.preventDefault()

  submitButton.setAttribute("disabled", true)
  donationForm.classList.add("is-submitting")

  const errors = validateDonationForm()

  if (errors.length > 0) {
    showErrorMessage(getErrorMessage(errors), messageContainer)
    submitButton.removeAttribute("disabled", true)
    donationForm.classList.remove("is-submitting")

    return false
  }

  updatePayment().then(async function() {

    const { paymentIntent, error } = await stripe.handleCardPayment(
      clientSecret, card, {
        payment_method_data: {
          billing_details: {
            name:  document.getElementById("donation-card-holder").value,
            email: document.getElementById("donation-email").value,
            address: {
              line1:       document.getElementById("donation-street").value,
              postal_code: document.getElementById("donation-zip").value,
              city:        document.getElementById("donation-city").value,
              country:     document.getElementById("donation-country").value
            }
          }
        }
      }
    )

    if (error) {
      showErrorMessage(error.message, messageContainer)
      submitButton.removeAttribute("disabled", true)
      donationForm.classList.remove("is-submitting")

    } else {

      const paymentIntentId = donationForm.getAttribute("data-stripe-intent-id")
      const amount          = getDonationAmount()

      fetch(`/stripe-api/success/${paymentIntentId}`, {
        method: "POST",
        body: JSON.stringify({
          data: {
            amount: amount,
            units:  getUnitsForDonation(amount),

            name:    document.getElementById("donation-card-holder").value,
            email:   document.getElementById("donation-email").value,
            street:  document.getElementById("donation-street").value,
            zip:     document.getElementById("donation-zip").value,
            city:    document.getElementById("donation-city").value,
            message: document.getElementById("donation-message").value,
            intentId: paymentIntentId,
          }
        })

      })
      .then(response => response.json())
      .then(() => {
        donationForm.classList.remove("is-submitting")
        donationForm.classList.add("is-finished")

        showSuccessMessage()

        doScrolling(0, 300)
      })
      .catch(() => {
        donationForm.classList.remove("is-submitting")
        donationForm.classList.add("is-finished")

        showSuccessMessage()

        doScrolling(0, 300)
      })
    }

  })

})



/* ---- Update donation result ------------------------ */

const updateResultHtml = (amount, units) => {
  const resultWrapper = document.querySelector(".form-donation-result")
  const resultAmount  = resultWrapper.querySelector(".amount")
  const resultUnits   = resultWrapper.querySelector(".units")

  resultAmount.innerHTML = amount.toFixed(0) + " " + resultAmount.getAttribute("data-suffix")
  resultUnits.innerHTML  = units.toString().replace(/\./, ',') + " " + resultUnits.getAttribute("data-suffix")

  resultWrapper.classList.remove("is-hidden")
}

const updateDonationResult = () => {
  const radioValue  = document.querySelector("input[name='donation-amount']:checked").value

  if (radioValue != "choose") {
    donationCustomAmount.removeAttribute("required")
    donationCustomAmount.parentElement.parentElement.classList.add("is-blurred-out")
  } else {
    donationCustomAmount.setAttribute("required", true)
    donationCustomAmount.parentElement.parentElement.classList.remove("is-blurred-out")
    donationCustomAmount.focus()
  }

  const donationAmount = getDonationAmount()
  const units          = getUnitsForDonation(donationAmount)

  if (donationAmount < donationCustomAmount.getAttribute("min")) {
    showErrorMessage(`Der Mindest-Spendenbetrag liegt bei ${donationCustomAmount.getAttribute("min")} Euro.`, messageContainer)
    return

  } else {
    hideErrorMessage(messageContainer)
  }

  updateResultHtml(donationAmount, units)

  submitButton.setAttribute("disabled", true)
  updatePayment().then(() => {
    submitButton.removeAttribute("disabled")
    submitButton.querySelector(".amount").innerHTML = donationAmount
  })
}

const donationAmountCheckboxes = document.querySelectorAll('input[name="donation-amount"]')
for (var i = donationAmountCheckboxes.length - 1; i >= 0; i--) {
  donationAmountCheckboxes[i].addEventListener("change", updateDonationResult)
}

donationCustomAmount.addEventListener("input", () => {
  document.getElementById("donation-amount-choose").click()
  updateDonationResult()
})
donationCustomAmount.addEventListener("click", () => {
  document.getElementById("donation-amount-choose").click()
})
donationCustomAmount.addEventListener("focus", () => {
  if (!donationCustomAmount.value) donationCustomAmount.value = 100
  donationCustomAmount.parentElement.parentElement.classList.remove("is-blurred-out")
})


// WEBPACK FOOTER //
// ./source/js/templates/donate.js